import React, {useEffect, useState} from 'react'
import SelectTags from "../../tag/select-tags";
import ImageSidebarSection from "../image-sidebar/image-sidebar-section";
import {searchTags} from "../../common/services/tag-data-service";
import ImageDetail from "../image-detail";
import _ from "lodash";
import ShowLink from "../../common/ui/show-link";
import EditImagesList from "./edit-images-list";
import {updateImages} from "../../common/services/image-data-service";
import SelectThemes from "../../theme/components/select-themes";
import {searchThemes} from "../../theme/services/theme-data-service";

const defaultTagDetail = {
    themes: {},
    themeList: [],
    tags: {},
    tagList: [],
};

const EditMultipleImagesHome = () => {
    const [initialStep, setInitialStep] = useState(true);
    const [allTags, setAllTags] = useState(null);
    const [allThemes, setAllThemes] = useState(null);
    const [allFilterTags, setAllTFilterTags] = useState(null);
    const [selectedImage, setSelectedImage] = useState(null);
    const [selectedImagesList, setSelectedImagesList] = useState([]);
    const [selectedImageIdsList, setSelectedImageIdsList] = useState([]);
    const [updateInProgress, setUpdateInProgress] = useState(false);
    const [showMessage, setShowMessage] = useState(false);
    const [selectedDetail, setSelectedDetail] = useState(defaultTagDetail);
    const [filterDetail, setFilterDetail] = useState(defaultTagDetail);
    const [refreshImages, setRefreshImages] = useState(false);

    useEffect(() => {
        if (initialStep) {
            getThemesList();
            fetchTagsList();
        }
    }, [initialStep]);

    const getThemesList = async () => {
        const themesListResult = await searchThemes('')
        setAllThemes(themesListResult);
    }

    const fetchTagsList = async () => {
        const tagsListResult = await searchTags('');
        setAllTags(tagsListResult);
        setAllTFilterTags(_.cloneDeep(tagsListResult));
    }

    const handleTagChanges = async (event) => {
        const {name, value} = event.target;
        const existingSelectedDetail = {...selectedDetail};
        existingSelectedDetail[name] = value;

        if (name === 'themeList') {
            const tempThemes = {};
            _.forEach(value, themeId => {
                tempThemes[themeId] = true;
            });

            existingSelectedDetail['themes'] = tempThemes;
            existingSelectedDetail['themeList'] = value;
        }

        if (name === 'tagList') {
            const tempTags = {};
            _.forEach(value, tagId => {
                tempTags[tagId] = true;
            });

            existingSelectedDetail['tags'] = tempTags;
            existingSelectedDetail['tagList'] = value;
        }

        setSelectedDetail(existingSelectedDetail);
    }

    const handleFilterTagChanges = async (event) => {
        const {name, value} = event.target;
        const existingFilterDetail = {...filterDetail};
        existingFilterDetail[name] = value;

        if (name === 'tagList') {
            const tempTags = {};
            _.forEach(value, tagId => {
                tempTags[tagId] = true;
            });

            existingFilterDetail['tags'] = tempTags;
            existingFilterDetail['tagList'] = value;
        }

        setFilterDetail(existingFilterDetail);
    }

    const handleRemoveAllImages = () => {
        setShowMessage(false);
        setSelectedImagesList([]);
        setSelectedImageIdsList([]);
    }

    const handleSelectAllImages = (imagesList) => {
        setShowMessage(false);
        const existingSelectedImagesList = [...selectedImagesList];
        const tempSelectedImageIdsList = _.map(existingSelectedImagesList, 'id');
        const existingSelectedImageIdsList = [...selectedImageIdsList];

        _.forEach(imagesList, (imageDetail) => {
            if (tempSelectedImageIdsList.indexOf(imageDetail.id) === -1) {
                existingSelectedImagesList.push(imageDetail);
                tempSelectedImageIdsList.push(imageDetail.id);
            }

            if (existingSelectedImageIdsList.indexOf(imageDetail.id) === -1) {
                existingSelectedImageIdsList.push(imageDetail.id);
            }
        });

        setSelectedImagesList(existingSelectedImagesList);
        setSelectedImageIdsList(existingSelectedImageIdsList);
    }

    const handleSelectedImage = (imageDetail) => {
        setShowMessage(false);
        const existingSelectedImagesList = [...selectedImagesList];
        const tempSelectedImageIdsList = _.map(existingSelectedImagesList, 'id');

        if (tempSelectedImageIdsList.indexOf(imageDetail.id) === -1) {
            existingSelectedImagesList.push(imageDetail);
        }

        const existingSelectedImageIdsList = [...selectedImageIdsList];
        if (existingSelectedImageIdsList.indexOf(imageDetail.id) === -1) {
            existingSelectedImageIdsList.push(imageDetail.id);
        }

        setSelectedImagesList(existingSelectedImagesList);
        setSelectedImageIdsList(existingSelectedImageIdsList);
    }

    const handleUpdateImages = async () => {
        setUpdateInProgress(true);
        const existingSelectedDetails = {...selectedDetail};
        const existingSelectedImagesList = [...selectedImagesList];
        const existingSelectedImageIdsList = [...selectedImageIdsList];
        const imagesListToUpdate = [];

        _.forEach(existingSelectedImagesList, (image) => {
            if (existingSelectedImageIdsList.indexOf(image?.id) !== -1) {
                image.tags = _.merge(image.tags, existingSelectedDetails.tags);
                image.tagList = _.compact(_.uniq(_.concat(image.tagList, existingSelectedDetails.tagList)));
                image.themes = _.merge(image.themes, existingSelectedDetails.themes);
                image.themeList = _.compact(_.uniq(_.concat(image.themeList, existingSelectedDetails.themeList)));

                imagesListToUpdate.push(image);
            }
        });

        await updateImages(imagesListToUpdate);
        setUpdateInProgress(false);
        setShowMessage(true);
        setSelectedImagesList([]);
        setSelectedImageIdsList([]);
        setSelectedDetail(defaultTagDetail);
        setRefreshImages(true);
    }

    return (
        <>

            <div className="page-container-background">
                <div className="flex justify-between items-center pt-8 px-8">
                    <div className="flex justify-start items-center">
                        <div className="mr-4">
                            <ShowLink label="Back"
                                      url="/images"/>
                        </div>

                        <div className="text-xl">
                            Edit Multiple Images
                        </div>
                    </div>

                    <div className="flex justify-end">
                        {!updateInProgress && !showMessage &&
                            <button onClick={handleUpdateImages}
                                    className="button-gray px-3 py-2">
                                Update Images
                            </button>
                        }

                        {updateInProgress &&
                            <button
                                disabled={true}
                                className="button-green-outline px-4 py-2 flex items-center justify-center">
                                <div
                                    className={`w-6 h-6 border-b-2 border-t-2 border-green-600 rounded-full animate-spin`}></div>
                                <div className="ml-2">Update In Progress...</div>
                            </button>
                        }

                        {(!updateInProgress && showMessage) &&
                            <div className="text-lg font-bold text-green-600">Images Updated</div>
                        }
                    </div>
                </div>

                <div className="flex justify-start w-full">
                    <div className="items-center justify-start w-1/3 px-8 py-2">
                        <div
                            className="design-editor-image-sidebar-container h-full">

                            {allFilterTags &&
                                <div
                                    className="h-44 overflow-y-scroll border-gray-400 border bg-blue-50 rounded mt-4">
                                    <SelectTags
                                        existingTags={filterDetail?.tagList}
                                        allTags={allFilterTags}
                                        handleSelectTagsChanges={handleFilterTagChanges}
                                        showAddTag={false}
                                        showClearSelectedTags={true}
                                        showClearSelectedTagsIcon={true}/>
                                </div>
                            }

                            <div
                                className="edit-multiple-images-sidebar-container-child overflow-y-scroll border-gray-400 border bg-gray-400 rounded mt-4">
                                <ImageSidebarSection
                                    setSelectedImage={handleSelectedImage}
                                    tags={filterDetail?.tagList}
                                    ignoreInitialSelection={true}
                                    selectedImageIdsList={selectedImageIdsList}
                                    refreshImages={refreshImages}
                                    setRefreshImages={setRefreshImages}
                                    showSelectAll={true}
                                    handleSelectAllImages={handleSelectAllImages}
                                    handleRemoveAllImages={handleRemoveAllImages}/>
                            </div>

                        </div>
                    </div>

                    <div className="edit-multiple-images-right-container w-2/3 mr-8 py-2">
                        {allTags &&
                            <div
                                className="h-44 overflow-y-scroll border-gray-400 border bg-blue-50 rounded mt-4">
                                <SelectTags
                                    existingTags={selectedDetail?.tagList}
                                    allTags={allTags}
                                    handleSelectTagsChanges={handleTagChanges}
                                    showAddTag="true"
                                    showClearSelectedTags={true}
                                    showClearSelectedTagsIcon={true}/>
                            </div>
                        }

                        {allThemes &&
                            <div
                                className="h-40 overflow-y-scroll border-gray-400 border bg-blue-50 mb-4 rounded mt-4">
                                <SelectThemes
                                    existingThemes={selectedDetail?.themeList}
                                    allThemes={allThemes}
                                    handleSelectThemesChanges={handleTagChanges}
                                    showClearSelectedThemes={false}
                                    showClearSelectedThemesIcon={false}/>
                            </div>
                        }

                        <EditImagesList
                            imagesList={selectedImagesList}
                            imageIdsList={selectedImageIdsList}
                            setImageIdsList={setSelectedImageIdsList}/>
                    </div>
                </div>
            </div>

        </>
    )
}

export default EditMultipleImagesHome
